<template>
  <div class="box">
    <div class="columns has-text-left">
      <div class="column is-narrow">
        <b-button
          rounded
          type="is-zero"
          style="padding: 1.2rem; cursor: default;"
        >
          <b-icon
            icon="microphone-alt"
            type="is-fff"
            style="position: relative; top: 2px;"
          ></b-icon>

          <b class="has-text-fff" style="position: relative; bottom: 4px;">
            DICA
          </b>
        </b-button>
      </div>

      <div class="column has-text-zero">
        Mantenha o Perfil da sua OE sempre atualizado e aumente as chances de
        serem convidados a participar de Parcerias Exclusivas com as Empresas
        Mentoras.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["text"]
};
</script>

<style scoped>
.container {
  margin-top: 5rem;
}
.box {
  padding: 2rem 3rem;
  max-width: 800px !important;
  margin: auto;
}
</style>
